const PROPERTY_TYPE_ABBREVIATIONS: Record<string, string> = {
  singlefamilyresidence: 'SFR',
  'single family residence': 'SFR',
  townhome: 'TH',
  townhouse: 'TH',
  multifamilyresidence: 'MFR',
  'multi family residence': 'MFR',
  'multi-family residence': 'MFR',
  'multi-family': 'MFR',
  multifamily: 'MFR',
  manufacturedhome: 'MFH',
  'manufactured home': 'MFH',
};

const normalizePropertyType = (propertyType: string): string =>
  propertyType.trim().toLowerCase().replace(/\s+/g, ' ');

export const formatPropertyTypeAbbreviation = (propertyType?: string): string => {
  if (!propertyType) return '';
  const normalized = normalizePropertyType(propertyType);
  const compacted = normalized.replace(/[\s-]/g, '');
  return (
    PROPERTY_TYPE_ABBREVIATIONS[normalized] ??
    PROPERTY_TYPE_ABBREVIATIONS[compacted] ??
    propertyType
  );
};
